<template>
  <SoPageWithHeader>
    <v-card>
      <v-toolbar class="px-4 py-2" density="compact" color="surface-dim">
        <v-toolbar-title>
          <h2 class="text-h4" data-testid="flow__title">New bill issued!</h2>
        </v-toolbar-title>
      </v-toolbar>
      <SoRow>
        <SoCol>
          <v-window class="pa-8 pt-3">
            <SoAlert
              class="mt-8"
              type="success"
              title="
              To see the full details please go to financials - bills. A copy of
              the bill will be sent to the customer via email."
            />
            <SoButton
              class="mt-12"
              type="primary"
              title="Go to financials"
              :to="`/customer/${current.accountNumber}/financials/transactions`"
              large
            />
          </v-window>
        </SoCol>
      </SoRow>
    </v-card>
  </SoPageWithHeader>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { FlowType } from "@/flows/useCases"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import SoPageWithHeader from "@/components/templates/SoPageWithHeader.vue"
  import { MeterpointService } from "@/services/MeterpointService"
  import SoAlert from "@/components/SoAlert.vue"
  import SoRow from "@/components/SoRow.vue"
  import SoCol from "@/components/SoCol.vue"
  import SoButton from "@/components/formControls/SoButton.vue"

  export default defineComponent({
    components: {
      SoButton,
      SoCol,
      SoRow,
      SoAlert,
      SoPageWithHeader,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
        MeterpointService: MeterpointService,
        FlowType,
      }
    },
  })
</script>
